import { render, staticRenderFns } from "./BusinessAccountHistory.vue?vue&type=template&id=13ba09b0&scoped=true&"
import script from "./BusinessAccountHistory.vue?vue&type=script&lang=js&"
export * from "./BusinessAccountHistory.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAccountHistory.vue?vue&type=style&index=0&id=13ba09b0&lang=scss&scoped=true&"
import style1 from "./BusinessAccountHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba09b0",
  null
  
)

export default component.exports